import { useMemo } from 'react';
import { PagePath } from '../../navigation/navigation.enums';
import { useAppState } from '../../overmind';

export function useAnalysisBasePagePath(): string {
  const { activeAssessmentConfig, forcedAssessments } = useAppState();
  return useMemo(() => (PagePath.analysisBase + (forcedAssessments.length > 1 ? PagePath.analysisPendingAssessmentsAssessment : PagePath.analysisAssessment)).replace(':assessmentSlug', activeAssessmentConfig?.assessmentSlug ?? ''), [activeAssessmentConfig, forcedAssessments]);
}
